<template>
  <div class="analysis">
    <div class="analysis-overview">
    <div class="analysis-head">
      <div class="analysis-head__num">01</div>
      <div class="analysis-head__title">练习概览</div>
    </div>
    <div class="p-select">
      <i class="el-icon-date"></i>
        <el-select popper-class="selectFrom" v-model="value" placeholder="" @change="timeChange">
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
    </div>
    </div>
    <div class="analysis-detail" v-if="evaluation_num!==0">
      <div class="analysis-list">
        <div class="analysis-item">
          <img src="../../images/test_num.png" alt="">
          <span>布置练习数</span>
          <span class="mr-20">{{evaluation_num}}<span class="fz-24">个</span></span>
        </div>
        <div class="analysis-item">
          <img src="../../images/class_study_day.png" alt="">
          <span>练习完成率</span>
          <span class="mr-20">{{complete_lv}}<span class="fz-24">%</span></span>
        </div>
        <div class="analysis-item">
          <img src="../../images/avg_lv.png" alt="">
          <span>平均正答率</span>
          <span class="mr-20">{{avg_accuary}}<span class="fz-24">%</span></span>
        </div>
      </div>
      <div class="subject-distribute ">
      <span class="title">布置学科分布</span>
      <div class="subject-charts">
        <div class="subject-bg">
          <p class="test-num">总练习次数</p>
          <p class="test-total">{{evaluation_num}}<span>次</span> </p>
          <div class="subject" ></div>
        </div>
      </div>
      </div>
    </div>
    <Empty content="暂无练习数据~" v-else/>
    <test-line :fromType="true"
    :classId="classId" :accuaryTrend="accuaryTrend" title="练习" v-if="accuaryTrend.length>0"
    :startDate="current_time"/>
    <span class="title">练习的知识点明细</span>
    <el-table
    :data="showTableList.slice((currentPage-1)*pageSize,currentPage*pageSize)"
    style="width: 100%"
    >
     <div slot="empty" class="no-data">
      <EmptyContent/>
    </div>
    <el-table-column
      prop="tag_name"
      label="知识点名称"
    >
      <template slot-scope="scope">
        <div style="color: #1989FA;">
          {{scope.row.tag_name}}
        </div>
      </template>
    </el-table-column>
     <el-table-column
      prop="tag_total"
      label="答题总次数"
      width="150"
      align="center"
      >
        <template slot-scope="scope">
      {{scope.row.tag_total!==-1?scope.row.tag_total:'--'}}
        </template>
    </el-table-column>
    <el-table-column
      prop="right_rate"
      label="客观题正答率"
      align="center"
      width="150"
      >
        <template slot-scope="scope">
      {{scope.row.right_rate!==-1?scope.row.right_rate+'%':'--'}}
        </template>
     </el-table-column>
    <el-table-column
      prop="avg_ability"
      label="平均掌握情况"
      align="center"
      width="350"
      :render-header="renderHeader"
      >

       <template slot-scope="scope">
         <div
          v-if="scope.row.avg_ability>=0.4
          &&scope.row.avg_ability<0.5" style="color:#F56C6C">
            <div class="flex"><div class="border" style="border: 1px solid #F56C6C;">生疏</div>
            <div class="pos">{{scope.row.avg_ability}}</div></div>
          </div>
          <div
          v-else-if="scope.row.avg_ability>=0.5&&scope.row.avg_ability<0.7" style="color:#F68236">
          <div class="flex"><div class="border" style="border: 1px solid #F68236;">一般</div>
          <div class="pos">{{scope.row.avg_ability}}</div></div>
          </div>
          <div v-else-if="scope.row.avg_ability>=0
          &&scope.row.avg_ability<0.4" style="color:#F2494A">
          <div class="flex"><div class="border" style="border: 1px solid #F2494A;">未掌握</div>
          <div class="pos">{{scope.row.avg_ability}}</div></div>
          </div>
          <div v-else-if="scope.row.avg_ability>=0.7
          &&scope.row.avg_ability<0.9" style="color:#ACE433">
          <div class="flex">
             <div class="border" style="border: 1px solid #ACE433;">较好</div>
          <div class="pos">{{scope.row.avg_ability}}</div>
          </div>
          </div>
          <div v-else-if="scope.row.avg_ability>=0.9
          &&scope.row.avg_ability<=1" style="color:#1ABF5F">
          <div class="flex">
            <div class="border" style="border: 1px solid #1ABF5F;">熟练</div>
          <div class="pos">{{scope.row.avg_ability}}</div>
          </div>
          </div>
          <div v-else>
            --
          </div>
      </template>
     </el-table-column>
    </el-table>
     <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="showTableList.length"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50]"
      :current-page="currentPage"
      @size-change="sizeChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import * as echarts from 'echarts';
import TestLine from './test-line.vue';
import { getClassExerciseAnalysis } from '@/api/pt';
import Empty from '@/views/pt/components/empty.vue';
import EmptyContent from '@/views/pt/components/empty-content.vue';

export default {
  name: 'JobAnalysis',
  components: {
    TestLine,
    Empty,
    EmptyContent,
  },
  props: {
    classId: {
      type: String,
      default: '',
    },
    gradeId: {
      type: String,
      default: '',
    },
    classCreateTime: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: '',
      options: [],
      colorOne: '',
      colorTwo: '',
      index: 0, // 下标
      subjectList: [],
      evaluation_num: 0, // 布置练习数
      complete_lv: 0, // 完成率
      avg_accuary: 0, // 平均正答率
      accuaryTrend: [], // 正答率的趋势
      showTableList: [],
      currentPage: 1,
      pageSize: 10,
    };
  },
  mounted() {
    this.options = this.getMonth();
    this.getClassExerciseAnalysis();
  },
  computed: {
    arrList() {
      const arr = [];
      this.subjectList.forEach((item) => {
        if (item.subject_id === 2) {
          this.colorOne = '#3DE974';
          this.colorTwo = '#38EB78';
        } else if (item.subject_id === 4) {
          this.colorOne = '#4FF3FF';
          this.colorTwo = '#64ECD4';
        } else if (item.subject_id === 1) {
          this.colorOne = '#FFF13B';
          this.colorTwo = '#FBEC50';
        } else if (item.subject_id === 3) {
          this.colorOne = '#FFA358';
          this.colorTwo = '#FFDA73';
        } else if (item.subject_id === 5) {
          this.colorOne = '#A472FF';
          this.colorTwo = '#8B9EFF';
        } else {
          this.colorOne = '#00F1FF';
          this.colorTwo = '#8A4FFF';
        }
        arr.push({
          value: item.num,
          name: item.subject_name,
          lv: item.lv,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                offset: 0,
                color: this.colorOne,
              }, {
                offset: 1,
                color: this.colorTwo,
              }]),
            },
          },
        });
      });
      return arr;
    },
  },
  watch: {
    // subjectList() {
    //   this.initCharts();
    // },
    classId() {
      this.options = this.getMonth();
      this.getClassExerciseAnalysis();
    },
  },
  methods: {
    async getClassExerciseAnalysis() {
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
      const params = {
        current_time: this.current_time,
        grade_id: this.gradeId,
        class_id: this.classId,
        school_id: userInfo.campusId,
      };
      const res = await getClassExerciseAnalysis(params);
      this.evaluation_num = res.data.evaluation_num;
      this.avg_accuary = res.data.avg_accuary;
      this.complete_lv = res.data.complete_lv;
      this.subjectList = res.data.subject_distribution;
      this.accuaryTrend = res.data.accuary_trend;
      this.showTableList = this.bubbleSort(res.data.knowledge_details);
      if (this.subjectList.length > 0) {
        const newPromise = new Promise((resolve) => {
          resolve();
        });
        newPromise.then(() => {
          this.initCharts();
        });
      }
    },
    timeChange(val) {
      this.current_time = val.substring(0, val.length - 1).replace('年', '-');
      this.getClassExerciseAnalysis();
    },
    getMonth() { // 获取时间列表
      const beforeMoth = dayjs(this.classCreateTime).add(1, 'month');
      const getmoth = dayjs(new Date()).add(1, 'month');
      if (getmoth.$M === 0) {
        this.value = `${getmoth.$y - 1}年${12}月`;
        this.current_time = `${getmoth.$y - 1}-${12}`;
      } else {
        this.value = `${getmoth.$y}年${getmoth.$M}月`;
        this.current_time = `${getmoth.$y}-${getmoth.$M}`;
      }
      const list = [];
      if (beforeMoth.$y === 2021 && beforeMoth.$M < 10 && getmoth.$M !== 9) {
        beforeMoth.$M = 10;
      }
      if (beforeMoth.$y < getmoth.$y) {
        for (let i = beforeMoth.$M; i <= 12; i += 1) {
          list.unshift({
            value: `${getmoth.$y - 1}年${i}月`,
            label: `${getmoth.$y - 1}年${i}月`,
          });
        }
        for (let i = 1; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      } else if (beforeMoth.$y === getmoth.$y && beforeMoth.$M === 0) {
        list.unshift({
          value: `${beforeMoth.$y - 1}年${12}月`,
          label: `${beforeMoth.$y - 1}年${12}月`,
        });
        for (let i = 1; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      } else {
        for (let i = beforeMoth.$M; i <= getmoth.$M; i += 1) {
          list.unshift({
            value: `${getmoth.$y}年${i}月`,
            label: `${getmoth.$y}年${i}月`,
          });
        }
      }
      return list;
    },
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.subject'));
      // 绘制图表
      const that = this;
      myChart.setOption({
        tooltip: {
          trigger: 'item',
        },
        legend: {
          x: '20%',
          y: '80%',
          // orient: 'vertical',
          icon: 'circle',
          textStyle: {
            color: '#303133',
            fontSize: 14,
          },
          formatter(val) {
            const { arrList } = that;
            arrList.forEach((v, i) => {
              if (v.name === val) {
                that.index = i;
              }
            });
            return `${val} | ${arrList[that.index].value}个  ${((arrList[that.index].lv))}%`;
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['32%', '42%'],
            center: ['50%', '50%'],
            labelLine: {
              length: 25,
              length2: 40,
            },
            label: {
              normal: {
                show: true,
                formatter(params) {
                  // console.log(params, 'params');
                  // 自定义颜色
                  const res = `{value|${params.data.lv}%}`;
                  return res;
                },
                rich: {
                  value: {
                    fontFamily: 'PingFangSC-Semibold, PingFang SC',
                    fontSize: 14,
                    color: '#303133',
                  },
                },
              },
            },
            data: this.arrList,
            // itemStyle: {
            //   borderColor: '#263180',
            // borderWidth: 10,
            // },
          },
        ],
      });
    },
    renderHeader(h, { column }) {
      return h('div', [
        h('span', column.label),
        h(
          'el-popover',
          {
            props: {
              title: '说明',
              trigger: 'hover',
              placement: 'top',
              content: '掌握情况仅统计"日常个性化练习"中的数据',
              width: '200',
            },
          },
          [
            h('span', {
              slot: 'reference',
              style: 'display:inline-block;width:14px;height:14px;border-radius: 7px;font-size: 13px;vertical-align:text-bottom;border: 1px solid #606266;line-height: 14px;margin-left:3px;',
            }, '?'),
          ],
        ),
      ]);
    },
    sizeChange(v) { // 每页条数
      this.currentPage = 1;
      this.pageSize = v;
    },
    currentChange(v) { // 当前页
      this.currentPage = v;
    },
    bubbleSort(arrList) {
      for (let j = 0; j < arrList.length - 1; j += 1) {
        for (let i = 0; i < arrList.length - 1 - j; i += 1) {
          if (arrList[i].avg_ability > arrList[i + 1].avg_ability) {
            /* eslint-disable */
            var temp = arrList[i];
            arrList[i] = arrList[i + 1];
            arrList[i + 1] = temp;
          }
        }
      }
      const arr = arrList.filter(item=>item.avg_ability>-1)
      const list = arrList.filter(item=>item.avg_ability===-1)
      arr.push(...list)
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.analysis{
  background: #fff;
  padding: 41px 60px 40px 31px;
  .title{
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    position: relative;
    &::before{
      content: '';
      position: absolute;
      width: 100%;
      height: 13px;
      background: rgba(60, 194, 230, 0.18);
      border-radius: 7px;
      left: 0;
      bottom: 3px;
    }
   }
  .analysis-overview{
  display: flex;
  justify-content: space-between;
  .analysis-head{
  display: flex;
  align-items: center;
  margin-bottom:11px ;
  &__num{
    font-size: 22px;
    
    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    margin-right: 14px;
    background:url('~@/views/pt/images/class_bg.png');
    background-size:cover;
    width:38px;
    height:29px;
    text-align: center;
  }
  &__title{
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
  }
  }
  .p-select{
    position: relative;
    /deep/ {
      .el-icon-date{
        position: absolute;
        z-index: 999;
        top: 12px;
        left: 14px;
      }
    }
  }
  /deep/ {
    .el-select {
      width: 184px;
      height: 40px;
      .el-input__inner{
        padding-left: 35px;
        color: #1890FF;
      }
    }
  }
 }
  .analysis-detail{
   margin-top: 40px;
   display: flex;
   .analysis-list{
     .analysis-item{
      margin-bottom: 32px;
      width: 350px;
      height: 110px;
      background: #F0F2F8;
      border-radius: 12px;
      display: flex;
      padding-left: 21px;
      align-items: center;
      img{
        width: 72px;
        height: 72px;
        margin-right:24px ;
      }
      span{
        font-weight: 500;
        color: #808BAA;
        font-size: 18px;
      }
      .mr-20{
        margin-left: 20px;
        color:#1989FA;
        font-size: 32px;
      }
      .fz-24{
        font-size: 24px;
        margin-left: 10px;
      }
    }
   }
   .subject-distribute{
     width: 500px;
     height: 500px;
     position: relative;
     margin-left: 50px;
   .title{
     position: absolute;
     top: 2%;
     left: 40%;
     transform: translate(-50%,-50%);
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      position: relative;
      &::before{
        content: '';
        position: absolute;
        width: 100%;
        height: 13px;
        background: rgba(60, 194, 230, 0.18);
        border-radius: 7px;
        left: 0;
        bottom: 3px;
      }
   }
   .subject-charts{
     position: absolute;
     top: 40%;
     left: 50%;
     transform: translate(-50%,-50%);
     .subject-bg{
        width: 248px;
        height: 248px;
        border-radius:50% ;
        background:#F1F7FF;
        position: relative;
        .subject{
          width: 500px;
          height: 500px;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
        .test-num{
          position: absolute;
          top: 43%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.6);
        }
        .test-total{
          position: absolute;
          top: 60%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: 34px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.6);
          span{
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.6);
          }
        }
     }
   }
  }
 }
}
  .tooltip{
    width: 16px;
    height: 16px;
    vertical-align:text-bottom;
    border-radius: 8px;
    font-size: 12px;
    border: 1px solid #1989FA;
    line-height: 16px;
    margin-left: 3px;
  }
.no-data {
  line-height: 1.8;
  padding: 30px 0;
}
.border{
  position: absolute;
  align-items: center;
  line-height: 22px;
  font-size: 12px;
  width: 52px;
  height: 22px;
  border-radius: 12px;
  top: 0;
  left: 115px;
  margin-right: 20px;
}
.flex{
  position: relative;
}
.pos{
  margin-left:40px ;
}
::v-deep {
  .el-table{
    margin-top: 40px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
  .el-pagination {
    margin-top: 20px;
    display: flex;
    width: calc(100% - 64px);
    & .btn-prev {
      margin-left: auto;
    }
  }
}
</style>
